import { useContext, forwardRef } from 'react';
import { Context } from '../../context/UserContext';
import BarcodeScannerButton from './BarcodeScannerButton';
import styles from './Input.module.css';

const Input = forwardRef(function Input(
    {
        type,
        text,
        name,
        placeholder,
        handleOnChange,
        handleOnBlur,
        handleOnFocus,
        value,
        title,
        required,
        multiple,
        inputWidth = '150px',
        readonly,
        disabled,
        min,
        max,
        textAlign,
        accept,
        capture,
        maxLength,
        autocomplete,
        hidden = false,
        barcodeScanner = false,
        barcodeScannerDisabled = false,
    },
    ref
) {
    const { parametro } = useContext(Context);
    const isColorInput = type === 'color';
    const scannerAtivo = barcodeScanner && type === 'text' && !hidden;

    return (
        <div className={`${styles.form_control} ${styles[parametro.tema]}`}>
            <label htmlFor={name} title={title}>
                {hidden ? '' : `${text}:`}
            </label>
            {isColorInput ? (
                <div>
                    <input
                        ref={ref ?? null}
                        type={type}
                        name={name}
                        id={name}
                        onChange={handleOnChange}
                        onBlur={handleOnBlur}
                        onFocus={handleOnFocus}
                        value={value}
                        title={title}
                        style={{
                            width: `var(--input-width, ${inputWidth})`,
                            textAlign: textAlign,
                            height: `37px`,
                            backgroundColor: value,
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                        }}
                        readOnly={readonly === true}
                        disabled={disabled === true}
                        {...(maxLength ? { maxLength } : {})} // ⬅️ só aplica se maxLength existir
                        autoComplete={autocomplete}
                        hidden={hidden}
                    />
                </div>
            ) : (
                <div
                    className={scannerAtivo ? styles.input_with_scanner : undefined}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        ...(scannerAtivo
                            ? {
                                  width: `var(--input-width, ${inputWidth})`,
                              }
                            : {}),
                    }}
                >
                    <input
                        className={scannerAtivo ? styles.scanner_input : undefined}
                        ref={ref ?? null}
                        type={type}
                        name={name}
                        id={name}
                        placeholder={placeholder}
                        onChange={handleOnChange}
                        onBlur={handleOnBlur}
                        onFocus={handleOnFocus}
                        value={type !== 'file' ? value : undefined}
                        title={title}
                        required={required}
                        style={{
                            width: scannerAtivo ? '100%' : `var(--input-width, ${inputWidth})`,
                            textAlign: textAlign,
                        }}
                        {...(multiple ? { multiple } : {})}
                        readOnly={readonly === true}
                        disabled={disabled === true}
                        min={min}
                        max={max}
                        accept={type === 'file' ? accept : undefined}
                        capture={type === 'file' ? capture : undefined}
                        {...(maxLength ? { maxLength } : {})} // ⬅️ só aplica se maxLength existir
                        hidden={hidden}
                    />
                    {type === 'range' && <span style={{ marginLeft: '10px' }}>{value}</span>}

                    {scannerAtivo && (
                        <div className={styles.scanner_icon}>
                            <BarcodeScannerButton
                                name={name}
                                handleOnChange={handleOnChange}
                                disabled={barcodeScannerDisabled || disabled === true || readonly === true}
                                iconOnly
                            />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
});

export default Input;
